import PublicationCoverImage from "../../../common/catalog/PublicationCoverImage";
import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";
import DetailInstructorBlock from "../../../common/detail/DetailInstructorBlock";
import DetailMetaList from "../../../common/detail/DetailMetaList";

export default function PublicationSummarySection({ publication }) {
	const authors = publication.profile_detail?.name
		? [
				{
					name: publication.profile_detail.name,
					avatar_url: publication.profile_detail.avatar_url,
					doctor_id: publication.profile_detail.id,
				},
			]
		: [];

	const metaItems = publication.j_create_datetime
		? [
				{
					label: "تاریخ انتشار",
					value: publication.j_create_datetime,
					dir: "ltr",
				},
			]
		: [];

	return (
		<div
			dir="ltr"
			className="flex flex-row items-start gap-5 md:flex-col-reverse"
		>
			<DetailAccentCard
				ariaLabel={publication.title}
				className="min-w-0 flex-1 md:w-full md:flex-none"
				bodyClassName="p-5 md:p-6"
			>
				<div dir="rtl" className="flex flex-col gap-4 text-right">
					<h1 className="font-Vazir-700 text-[20px] md:text-[22px] text-darkBlue leading-snug">
						{publication.title}
					</h1>

					<div>
						<DetailSectionHeading className="mb-2 md:text-[15px]">
							اطلاعات مقاله
						</DetailSectionHeading>
						<div className="flex flex-col gap-3">
							{metaItems.length > 0 && (
								<DetailMetaList items={metaItems} columns={1} />
							)}
							<DetailInstructorBlock
								instructors={authors}
								label="نویسنده"
								emptyMessage="نویسنده ثبت نشده"
							/>
						</div>
					</div>
				</div>
			</DetailAccentCard>

			<DetailAccentCard
				ariaLabel="تصویر مقاله"
				className="w-[340px] shrink-0 md:mx-auto md:w-full md:max-w-[380px]"
				bodyClassName="p-4 md:p-5"
			>
				<PublicationCoverImage
					src={publication.image_url}
					alt={publication.title || ""}
					variant="detail"
					className="rounded-[12px]"
				/>
			</DetailAccentCard>
		</div>
	);
}
